import { memo, useState } from 'react';
import { selectSecondaryFilter, updateAllSecondaryFilter } from './secondaryFilterSlice';
import { selectGlobalLoading, setLastChangedFilter } from '../../appSlice';
import translate from '../../utilities/translator';
import Sort from './Sort';
import { updateSecondaryFilterModal } from './secondaryFilterModalsSlice';
import { toggleCustomizePanel } from '../customize-button/customizeButtonSlice';
import { CUSTOMIZE } from '../../constants/constants';
import { isMobile, parseDate, scrollToResults } from '../../utilities/helpers';
import Filters from '../customize-button/containers/Filters';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { updateBudgetFilter, updateDatesFilter } from '../mainFilter/mainFilterSlice';
import { updateSearch } from '../mainFilter/searchSlice';
import { clearPrefetchDeals } from '../dealsList/prefetchDealsSlice';

// new top mobile filters/sort panel (abTest.mobileFilterSort)
const MobileFilterSort = () => {
  const dispatch = useAppDispatch();
  const secondaryFilter = useAppSelector(selectSecondaryFilter);
  const { pending } = secondaryFilter;
  const { secondaryFilterLoading } = useAppSelector(selectGlobalLoading);
  const { budget, when } = useAppSelector(state => state.mainFilter.searchEngine);
  const { secondaryFilter: secondaryFilterModals } = useAppSelector((state) => state.modals);
  const { sort } = secondaryFilterModals;
  const [showFilters, setShowFilters] = useState(false);

  const formattedWhenSelection = {
    ...when,
    startDate: when.startDate ? parseDate(when.startDate) : null,
    endDate: when.endDate ? parseDate(when.endDate) : null,
  }

  const applyFilterChanges = ({ filters, nights, budget }) => {
    dispatch(clearPrefetchDeals());
    dispatch(updateDatesFilter({
      ...when,
      nights,
    }));
    // new
    dispatch(
      updateSearch({
        when: {
          ...when,
          nights,
        },
      })
    );

    dispatch(updateBudgetFilter(budget));
    dispatch(updateAllSecondaryFilter({ updatedFilters: filters }));
    dispatch(setLastChangedFilter('filters'));
    setShowFilters(false);
    scrollToResults();
  };

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const openFilters = () => {
    setShowFilters(true);
    dispatch(toggleCustomizePanel(CUSTOMIZE.FILTERS));
  };

  const handleShowModals = (isOpen: boolean, filterName: string) => {
    dispatch(updateSecondaryFilterModal({ [filterName]: isOpen }));
  };

  if (secondaryFilterLoading || pending) {
    return '';
  }

  return (
    <div className="mob-filter-sort flex items-center justify-between">
      <span className="mfs-filters-btn flex items-center gap-2 cursor-pointer" onClick={openFilters}>
        <i className="ri-equalizer-line" />
        <span>{translate('holidayFinder.customize.filters')}</span>
        <span />
      </span>

      <Filters
        onSave={applyFilterChanges}
        selected={secondaryFilter.data}
        nightsSelection={when.nights || []}
        budgetSelection={[budget.min, budget.max]}
        whenSelection={formattedWhenSelection}
        handleClosePanel={handleToggleFilters}
        show={showFilters}
        onClose={handleToggleFilters}
      />

      <div className="mfr-sort">
        {isMobile() &&
          <Sort
            isOpen={sort}
            setIsOpen={(isOpen: boolean) => handleShowModals(isOpen, 'sort')}
          />
        }
      </div>
    </div>
  );
};

export default memo(MobileFilterSort);
